import { formatNumber } from "../data/essential";
export const paymentColumns = () => {
    const columns = [
      {
        name: "Datetime",
        cell: (row) => row["datetime"],
      },
      {
        name: (
          <div className='sc-dQoVA huizgM'>
            Collection
            <br /> Account
          </div>
        ),
        cell: (row) => row["collectionAccount"],
      },
      {
        name: "Account",
        cell: (row) => (
          <div style={{ cursor: "pointer" }}>{row["accountId"]}</div>
        ),
      },
      {
        name: "Payer",
        cell: (row) => <div style={{ whiteSpace: "nowrap" }}>{row?.payer}</div>,
      },
      { name: "Names", cell: (row) => row["accountNames"] },
      { name: "Amount", cell: (row) => `${formatNumber(row["amount"])}F` },
      { name: "Location", cell: (row) => row["village"] },
      { name: "TID", cell: (row) => row["transactionId"] },
    ];
    return columns
}
